import * as React from 'react';

import AccountNavigation from 'user/components/AccountNavigation';
import AccountNavigationDeprecated from 'user/components/AccountNavigationDeprecated';
import CurrentUser from 'auth/CurrentUser';
// @ts-ignore
import NavigationList from 'components/NavigationList';
// @ts-ignore
import NavigationListDeprecated from 'components/NavigationListDeprecated';

import './styles/AppSidebarLayout.scss';

type Props = {
  children?: React.ReactNode;
};

export default function AppSidebarLayout(props: Props) {
  const hasNewNavList =
    CurrentUser.isSignedIn() &&
    CurrentUser.getUser()?.hasFeature('restyled_navigation_list_with_coaching.web.dec-20');
  return (
    <div className="AppSidebarLayout">
      <div className="AppSidebarLayout-inner">
        <div className="AppSidebarLayout-heightSetter">
          <div className="AppSidebarLayout-contentWrap">
            <div className="AppSidebarLayout-sidebar">
              {hasNewNavList ? (
                <AccountNavigation data-test="new-account-nav" />
              ) : (
                <AccountNavigationDeprecated data-test="old-account-nav" />
              )}
              {hasNewNavList ? (
                <NavigationList data-test="new-nav-list" />
              ) : (
                <NavigationListDeprecated data-test="old-nav-list" />
              )}
            </div>
            <div className="AppSidebarLayout-content">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
